import React, { Component, Fragment } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { registerAccount } from '../Actions/WebsiteActions';
import Header from './Common/Header';
import Footer from './Common/Footer';
import { supplier_login } from "../Actions/Config"
import Helmet from './Common/Helmet'

const mapStateToProps = (state) => {
    return {
        supplierSignUpComplete: state.Website.supplierSignUpComplete
    }
}

const mapDispatchToProps = dispatch => ({
    createAccount: (data, UserType) => dispatch(registerAccount(data, UserType))
});
class SupplierEmailVerified extends Component {

    constructor(props) {
        super(props);


        this.state = {
            first_name: null,
            last_name: null,
            email: null,
            password: null,
            confim_password: null

        }

    }

    handleUpdate = (event, field) => {
        this.setState({
            [field]: event.target.value
        })
    }


    SupplierAccountLogin = () => {
        window.location.href = supplier_login;
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return <Fragment>
            <Header />
			<Helmet 
				title="Belihuloya Trails"
				description="Supplier email verification"
			/>
            <section className="gry-log">
                <div className="row">
                    <div className="container">
                        <div className="col l12 m12 s12">
                            <div className="log-head">
                                <h1>Email Verified!</h1>
                                <p>Your account is now verified, please <a onClick={() => { this.SupplierAccountLogin() }} style={{ cursor: 'pointer' }} >  login</a> to your account and complete your profile. While we will review your account. you can start creating your activities right away.  </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="cont-log">
                <div className="row">
                    <div className="container">
                        <div className="col l12 m12 s12">
                            <div className="log-head">
                                <div className="log-btn">
                                    <i className="waves-effect waves-light btn waves-input-wrapper"><input type="submit" onClick={() => { this.SupplierAccountLogin() }} style={{ cursor: 'pointer' }} value="Supplier Account Login" /></i>


                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />

        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(SupplierEmailVerified);